import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import FeaturedItemCard from './FeaturedItemCard'

const FeaturedItems= ({featuredItems}) => {
    //until we start having more than just documents, we are not going to show the resource type
    // const ResourceType = ({resourceType}) => {
    //     if (resourceType === "Document")
    //     {
    //         return <FontAwesomeIcon icon={faFileAlt} size="lg"/>
    //     }
    //     if (resourceType === "Database")
    //     {
    //         return <FontAwesomeIcon icon={faDatabase} size="lg"/>
    //     }
    //     if (resourceType === "Website")
    //     {
    //         return <FontAwesomeIcon icon={faLink} size="lg"/>
    //     }
    // }

    if(!featuredItems) return null;

    return (
        <>
        <Row>
             <Col>
             <h2 className="text-left">Featured Content</h2>
             </Col>
        </Row>
        <Row className="row-flex featured-cards">
            {featuredItems.map(item => (
                <FeaturedItemCard featuredItem={item} key={item.uid}/>
                ))
            }
        </Row>
        </>
    )
}

export default FeaturedItems;